module.exports = __webpack_public_path__ + "static/media/ermerAccess-white.2be785cc.svg";